import Lottie from 'react-lottie';
import animationData from './animationDataV2.json';

type LoginError = {
  message: string;
};

const ERROR_TYPES = {
  UNAUTHORIZED: 'No',
  RETRY: 'RETRY',
  NOT_SECURE: 'UNSECURE',
};

const LoginError = ({ message }: LoginError) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const ERROR_TYPE = message.split(' ')[0].toUpperCase();

  let errorContent;

  switch (ERROR_TYPE) {
    case ERROR_TYPES.UNAUTHORIZED:
      errorContent = (
        <p className="text-secondary-300">
          You do not have permission to access{' '}
          <span className="font-bold">MEO</span> at this time <br />
          If this is your first time logging in, your administrator may still be
          assigning your role. Please try again in 15 minutes.
        </p>
      );
      break;
    case ERROR_TYPES.RETRY:
      errorContent = (
        <p className="text-secondary-300">
          Unable to log in. If this is your first time logging in using{' '}
          <span className="text-blue-600 font-semibold bg-gray-100 px-2 py-1 rounded">
            SSO
          </span>
          , please try again.
        </p>
      );
      break;
    case ERROR_TYPES.NOT_SECURE:
      errorContent = (
        <p className="text-secondary-300">
          The connection is not secure. Please log in using{' '}
          <span className="text-blue-600 font-semibold bg-gray-100 px-2 py-1 rounded">
            SSO
          </span>
          instead.
        </p>
      );
      break;
    default:
      break;
  }

  return (
    <div className="flex flex-col items-center text-center">
      <Lottie options={defaultOptions} height={180} width={250} />
      <div className="flex flex-col gap-4">
        <h2 className="text-blue font-semibold tracking-wider">
          Access Denied
        </h2>
        {errorContent}
        <div className="text-secondary-300">
          If this error persists, please submit a request to{' '}
          <span className="text-blue-600 font-semibold bg-gray-100 px-2 py-1 rounded">
            support@meocontinuity.com
          </span>
        </div>
        <a href="/login">Return to Login Page</a>
      </div>
    </div>
  );
};

export default LoginError;
